import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Lightweight SEO helper: updates <title> and key meta tags
 * per route without adding a dependency.
 */
export function Seo({ title, description, image }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const finalTitle = title
      ? `${title} — IVrenovation`
      : "IVrenovation — Renovation & Construction in Toronto and the GTA";
    document.title = finalTitle;

    const set = (selector, attr, value) => {
      if (!value) return;
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", finalTitle);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:url"]', "content", window.location.href);
    if (image) {
      set('meta[property="og:image"]', "content", image);
      set('meta[name="twitter:image"]', "content", image);
    }
    set('meta[name="twitter:title"]', "content", finalTitle);
    set('meta[name="twitter:description"]', "content", description);

    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + pathname);
  }, [title, description, image, pathname]);

  return null;
}
